import { render } from "./CommunityTalkNice.vue?vue&type=template&id=0cf19050&ts=true"
import script from "./CommunityTalkNice.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommunityTalkNice.vue?vue&type=script&lang=ts&setup=true"

import "./CommunityTalkNice.vue?vue&type=style&index=0&id=0cf19050&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/CommunityTalkNice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0cf19050"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0cf19050', __exports__)) {
    api.reload('0cf19050', __exports__)
  }
  
  module.hot.accept("./CommunityTalkNice.vue?vue&type=template&id=0cf19050&ts=true", () => {
    api.rerender('0cf19050', render)
  })

}


export default __exports__